/** A revoked public composition must be reloaded as a whole, never repaired one tile at a time. */
export function installMapVersionRefresh({ root = document, request = fetch, reload = () => location.reload(),
    storage, location: pageLocation = location, now = Date.now } = {}) {
    if (storage === undefined) { try { storage = sessionStorage; } catch { return () => {}; } }
    const pending = new Set();
    let alive = true;
    let reloading = false;
    const key = `map-assets:composition-refresh:${pageLocation.pathname}`;
    const onError = async (event) => {
        const target = event.target;
        if (!alive || reloading || target?.tagName !== 'IMG') return;
        let url;
        try { url = new URL(target.currentSrc || target.src, pageLocation.href); } catch { return; }
        if (url.origin !== pageLocation.origin || !/^\/(?:public|api)\/map-assets\/tiles\//.test(url.pathname) || pending.has(url.href)) return;
        pending.add(url.href);
        try {
            const response = await request(url.href, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
            if (!alive || reloading || response.status !== 410) return;
            const body = await response.json();
            if (body.code !== 'MAP_VERSION_CHANGED' && body.error !== 'MAP_VERSION_CHANGED') return;
            // If browser storage is disabled, decline automatic reload rather than create a reload loop.
            const last = Number(storage.getItem(key) || 0);
            if (now() - last < 60_000) return;
            storage.setItem(key, String(now()));
            reloading = true;
            reload();
        } catch { /* An ordinary tile/network error must not navigate the user away. */ }
        finally { pending.delete(url.href); }
    };
    root.addEventListener('error', onError, true);
    return () => { alive = false; root.removeEventListener('error', onError, true); };
}
